import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Circles } from "react-loader-spinner";
import { Helmet, HelmetProvider } from "react-helmet-async";
// import './style1.css';

const online = "https://api.shabdtoday.com/api/home/getwebstories/";
const local = "https://localhost:44351/api/home/getwebstories/";

function WebStrorieD() {
  const { webStoriesId } = useParams();
  const [newsDetails, setNewsDetails] = useState(null);


  useEffect(() => {
    const fetchNewsDetails = async () => {
      try {
        const { data } = await axios.get(`${online}${webStoriesId}`);
        // console.log("Fetched data:", data);
        setNewsDetails(data);
      } catch (error) {
        console.error("Error fetching news details:", error);
      }
    };

    fetchNewsDetails();
  }, [webStoriesId]);

  const BASE_URL = "https://api.shabdtoday.com/";
  const BASE_URLLocal = "https://localhost:44351/";
  const image_resize = "https://api.shabdtoday.com/api/home/resize";

  // if (!newsDetails) {
  //   return (
  //     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
  //       <Circles height="50" width="50" color="#f7265c" ariaLabel="loading" visible={true} />
  //     </div>
  //   );
  // }
  if (!newsDetails) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        {/* <Circles height="50" width="50" color="#f7265c" ariaLabel="loading" visible={true} /> */}
      </div>
    );
  }

  const imagesWithHeadings = [];

  const thumbImage = newsDetails.webStoryThumbNail_Image || newsDetails.webStoryThumbNailImage;
  if (thumbImage) {
    imagesWithHeadings.push({
      image: thumbImage,
      heading: newsDetails.webStoryThumbNail_Heading || "शब्द टुडे",
    });
  }

  for (let i = 1; i <= (newsDetails.image_Count || 0); i++) {
    const imageKey = `webStoriesImage_${i}`;
    const headingKey = `webStoryHeading_${i}`;

    if (newsDetails[imageKey]) {
      imagesWithHeadings.push({
        image: newsDetails[imageKey],
        heading: newsDetails[headingKey] || newsDetails.webStoryThumbNail_Heading || "शब्द टुडे",
      });
    }
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>शब्द टुडे | हिंदी न्यूज़</title>
          <script defer src="https://cdn.ampproject.org/v0.js"></script>
          <script defer custom-element="amp-story" src="https://cdn.ampproject.org/v0/amp-story-1.0.js"></script>
          <style amp-custom>{`@keyframes slideUp {
  from {
    transform: translate(-50%, 20px);
    opacity: 0;
    visibility: hidden;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
    visibility: visible;
  }
}
.webstory-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  z-index: 9999; /* stay on top */
}

.webstory-container amp-story {
  width: 100%;
  height: 100%;
}

/* Hide footer when webstory is open */
.webstory-container ~ footer {
  display: none !important;
}
.webstory-container {
  width: 100%;
  height: 100%;
  background: black;
}

amp-story {
  width: 100%;
  height: 100%;
}

/* Default state (hidden) */
.animated-heading {
  color: white;
  text-align: center;
  padding: 15px;
  font-size: 20px;
  font-weight: bold;
  position: absolute;
  bottom: 20px;
  left: 50%;
  font-size:15px;
  text-shadow: 
    -1px -1px 0 black,  
     1px -1px 0 black,
    -1px  1px 0 black,
     1px  1px 0 black;
  transform: translate(-50%, 20px);
  width: 90%;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
}

amp-story-page[active] .animated-heading {
  animation: slideUp 0.8s ease-out forwards;
}
.back-btn-layer {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 9999;
}

.back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 50%;
  box-shadow: 0 3px 8px rgba(0,0,0,0.3);
  transition: background 0.2s ease;
}

.back-button:hover {
  background: rgba(0,0,0,0.8);
}


`}</style>
        </Helmet>
      </HelmetProvider>

      <amp-story
        class="webstory-container"
        standalone
        publisher="शब्द टुडे"
        title={newsDetails.webStories_Tag}
      >
        <amp-story-grid-layer template="vertical" class="back-btn-layer">
          <a href="https://shabdtoday.com/Webstorie-News" class="back-button" style={{ position: "relative", top: "-30px", left: "-20px" }} aria-label="Go Back">
            &#8592;
          </a>
        </amp-story-grid-layer>
        {imagesWithHeadings.map((item, index) => (
          <amp-story-page key={index} id={`page-${index + 1}`}>
            <amp-grid-layer template="fill">
              <amp-img
                src={`${BASE_URL}/${item.image}`}
                width="900"
                height="1600"
                alt={`Image ${index + 1}`}
                layout="fill"
              ></amp-img>
            </amp-grid-layer>

            <amp-grid-layer template="vertical" position="bottom">
              <div className={`animated-heading page-${index + 1}`}>
                {item.heading}
              </div>
            </amp-grid-layer>
          </amp-story-page>
        ))}
      </amp-story>

    </>

  );

}

export default WebStrorieD;
